import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import SovosFlatButton from 's1-ui/sovos-flat-button/SovosFlatButton';

class ImportErrorDialog extends React.Component {

  handleDismissDialog = () => {
    this.props.filesActions.resetFileUploadFailed();
    this.props.onDialogClose();
  };

  render () {
    const { failedImport, errorMessage } = this.props;
    return(
      <div>
        <Dialog
          actions={ [
            <SovosFlatButton
              key="submit-delete"
              onClick={ this.handleDismissDialog }
            >
              Close
            </SovosFlatButton>
          ] }
          modal={ false }
          open={ failedImport }
          onRequestClose={ this.handleDismissDialog }
        >
          { errorMessage }
        </Dialog>
      </div>
    );
  }
}

ImportErrorDialog.propTypes = { 
  failedImport: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  onDialogClose: PropTypes.func.isRequired,
  filesActions: PropTypes.shape({
    resetFileUploadFailed: PropTypes.func
  }).isRequired
};

export default ImportErrorDialog;



// WEBPACK FOOTER //
// ./src/components/importData/comp/importErrorDialog/ImportErrorDialog.js